import React, {useMemo} from 'react'
import {Button, useSlotRecipe} from '@chakra-ui/react3'
import {Link as RouterLink} from 'react-router-dom'
import {useIntl} from 'react-intl'

import useMultiSite from '../../../hooks/use-multi-site'
import {COUNTRY_SELECTOR_HREF} from '../../../constants'
import FlagIcon from '../icons/flag-icon'
import {COUNTRY_SELECTOR_BUTTON_PROPS, countrySelectorLinkRecipe} from './index.recipe'

const CountrySelectorLink = () => {
    const {formatMessage} = useIntl()
    const {buildUrl, locale} = useMultiSite()
    const recipe = useSlotRecipe({recipe: countrySelectorLinkRecipe})
    const styles = useMemo(() => recipe(), [recipe])
    const [language, country] = useMemo(() => (locale?.id || '').split('-'), [locale])
    const localeLabel = useMemo(
        () => [language, country].filter(Boolean).join('/').toUpperCase(),
        [language, country]
    )
    const ariaLabel = formatMessage({
        id: 'header.button.assistive_msg.select_location',
        defaultMessage: 'Select current location'
    })

    return (
        <Button
            as={RouterLink}
            to={buildUrl(COUNTRY_SELECTOR_HREF)}
            css={styles.root}
            aria-label={ariaLabel}
            {...COUNTRY_SELECTOR_BUTTON_PROPS}
        >
            <FlagIcon css={styles.icon} countryCode={country} />
            <span>{localeLabel}</span>
        </Button>
    )
}

export default CountrySelectorLink
